import { ChangeDetectionStrategy, Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { ITodoListViewer } from '../fi-todo';
import { FiTodoActionsBuilderService } from '../fi-todo-actions-builder.service';
import { IItemsListAction2 } from '@fi-app/shared/fi-items-list/fi-items-list';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { SideListOptionType } from '@fi-app/shared/types';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';

@Component({
    selector: 'fi-todo-view',
    templateUrl: './fi-todo-view.component.html',
    styleUrl: './fi-todo-view.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-todo-view' },
    standalone: false,
})
export class FiTodoViewComponent {
    @Input({ required: true }) todoListViewer: ITodoListViewer;
    private fiTodoActionsBuilderService = inject(FiTodoActionsBuilderService);
    private readonly fiStateService = inject(FiStateService);

    protected readonly actions: IItemsListAction2<ITodoListViewer>[] = this.fiTodoActionsBuilderService.getTodoActions({
        onTodoDeletedFn: () =>
            this.fiStateService.go(FiStateNames.Onboarding.Todo.List, { filterType: SideListOptionType.SharedWithMe }),
    });

    protected back(): void {
        window.history.back();
    }
}
